/**
 * @Author: Li, Yu Jia
 * @Date: 2020-04-27 15:49:14
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-04-27 15:50:09
 */

import TopNavLink from './TopNavLink';

export default TopNavLink;
